export const createObjectiveSuggestionDrawerStrategy = "help me write an okr";

export enum CreateObjectiveSuggestionDrawerNoSuggestionReasonsEnum {
  YOUR_OBJECTIVE_ALREADY_HAS_A_TITLE = "your_objective_already_has_a_title",
  ENTER_SESSION_AND_OWNER_TO_VIEW_SUGGESTIONS = "enter_session_and_owner_to_view_suggestions",
  ENTER_SESSION_TO_VIEW_SUGGESTIONS = "enter_session_to_view_suggestions",
  ENTER_OWNER_TO_VIEW_SUGGESTIONS = "enter_owner_to_view_suggestions",
}
